module.exports = __webpack_public_path__ + "static/media/thumbnail.c88c1238.jpg";